import { GQLIdEncoder } from '../../../common/utils/GQLIdEncoder';
import { ReportKey } from '../models/ReportKey';
import { Project } from '../models/valueObjects/Project';

export class ReportKeyMapper {
  readonly gqlIdEncoder = new GQLIdEncoder();

  mapGQLModel(data: any): ReportKey {
    const project = data.report.project ? new Project(this.gqlIdEncoder.decode(data.report.project.id), data.report.project.name) : null;

    return new ReportKey(this.gqlIdEncoder.decode(data.id), data.operationSummary ?? '', this.gqlIdEncoder.decode(data.report.id), data.report.name, project);
  }
}
